var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowTopFillCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6003 13.1664C16.4419 13.1664 16.2836 13.1081 16.1586 12.9831L10.7253 7.54974C10.3253 7.14974 9.67526 7.14974 9.27526 7.54974L3.84193 12.9831C3.60026 13.2247 3.20026 13.2247 2.95859 12.9831C2.71693 12.7414 2.71693 12.3414 2.95859 12.0997L8.39193 6.66641C9.27526 5.78307 10.7169 5.78307 11.6086 6.66641L17.0419 12.0997C17.2836 12.3414 17.2836 12.7414 17.0419 12.9831C16.9169 13.0997 16.7586 13.1664 16.6003 13.1664Z",
    fill: "#E3CDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTopFillCircle);
export default __webpack_public_path__ + "static/media/arrow-top-fill-circle.4f442db1626eb874c5189b14b2b1bc0f.svg";
export { ForwardRef as ReactComponent };